const statusDeliveryAddressChoice = [
    { id: 0, name: 'Confirmada' },
    { id: 1, name: 'Devolvida' },
    { id: 2, name: 'Extraviada' },
]

export default statusDeliveryAddressChoice;
